import type { SxProps, Theme } from '@mui/material';

export const documentGenerationFormStyles = {
  form: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
    maxWidth: 1840,
    mx: 'auto',
    py: theme.spacing(1),
  }),
  section: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: 0,
    backgroundColor: 'transparent',
  }),
  sectionTitle: (theme: Theme) => ({
    color: theme.palette.text.primary,
    fontSize: '1rem',
    fontWeight: 800,
    lineHeight: '20px',
    mb: theme.spacing(0.5),
  }),
  fieldsGrid: (theme: Theme) => ({
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' },
    gap: theme.spacing(2),
  }),
  field: {
    width: '100%',
    minWidth: 0,
  } as SxProps<Theme>,
  checkbox: (theme: Theme) => ({
    alignSelf: 'flex-start',
    margin: 0,
    padding: theme.spacing(1, 1.5),
    border: `1px solid ${theme.palette.border.subtle}`,
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.background.tableHeader,
  }),
  addButton: (theme: Theme) => ({
    alignSelf: 'flex-start',
    borderRadius: '100px',
    fontWeight: 700,
    textTransform: 'none',
    px: theme.spacing(2),
  }),
} as const;
